import { useContext } from 'react'
import Text from 'components/base/Text'
import styled from 'styled-components'
import css from '@styled-system/css'
import { Box, colors } from '@careguide/theme'
import Avatar from 'components/generic/Avatar'
import { AppContext } from 'contexts/AppContext'
import ProfileCard from '../ProfileCard/ProfileCard'

export const MessageSendSuccessfulBox = ({
  firstName,
  conversationPath,
  avatar,
  similarListings,
  city,
  state,
}) => {
  const { site } = useContext(AppContext)
  const hasSimilarListings = similarListings.length > 0
  const listingCityName = city?.name
  const listingStateName = state?.name

  return (
    <Box>
      <Text as='h2' variant='heading' mt={0}>
        Great! Your message was sent to {firstName}!
      </Text>
      <Avatar url={avatar?.mediumUrl} height='128px' width='128px' />
      <Text mt={2}>
        Continue your conversation with {firstName} in your{' '}
        <StyledLink href={conversationPath}>inbox</StyledLink>.
      </Text>
      {hasSimilarListings && (
        <SimilarListingsContainer>
          <Text>
            Here are similar {site.keyword}s that may interest you in
            {` ${listingCityName}, ${listingStateName}`}:
          </Text>
          {similarListings.map((listing, i) => (
            <ProfileCard key={i} profile={listing} />
          ))}
        </SimilarListingsContainer>
      )}
    </Box>
  )
}

const StyledLink = styled.a`
  text-decoration: none;
  ${css({
    color: 'primary.600',
  })}
`

const SimilarListingsContainer = styled(Box)`
  border-top: solid 1px ${colors.gray[4]};
  text-align: left;
`
